<div class="analyst-notes-section">
  <hyperkit-typography
    variant="emphasized"
    size="sm"
    align="left"
    color="primary"
    >Analyst Notes</hyperkit-typography
  >
  <div class="analyst-notes-container">
    @for (note of trimmedNotes; track note; let i = $index) {
      <hyperkit-ellipsis
        class="analyst-note-ellipsis"
        [lineCount]="4"
        [isExpanded]="i === 0"
      >
        @if (note.analyst_note_date || note.analyst_note_type) {
          <ng-template #headerTemplate>
            @if (isIntelAuthor(note.analyst_note_author)) {
              <img
                src="/assets/brand/intel-bug-{{ theme() }}.svg"
                [alt]="note.analyst_note_author"
                class="intel-bug-image"
              />
            }
            <div class="analyst-note-header">
              @if (note.analyst_note_date) {
                <hyperkit-typography
                  variant="emphasized"
                  size="md"
                  align="left"
                  color="primary"
                  >{{
                    note.analyst_note_date | date: 'longDate'
                  }}</hyperkit-typography
                >
              }
              @if (note.analyst_note_type) {
                <hyperkit-badge
                  variant="neutral"
                  [text]="note.analyst_note_type"
                  class="note-header-badge"
                ></hyperkit-badge>
              }
            </div>
          </ng-template>
        }
        <div class="analyst-note">
          @if (note.current_analyst_note && !note.analyst_note_summary) {
            <hyperkit-markdown
              [md]="note.current_analyst_note"
            ></hyperkit-markdown>
          } @else {
            @if (note.analyst_note_summary) {
              <hyperkit-markdown
                [md]="note.analyst_note_summary"
              ></hyperkit-markdown>
            }
            @if (note.analyst_note_attribution) {
              <div class="analyst-note-section">
                <hyperkit-markdown
                  [md]="note.analyst_note_attribution"
                ></hyperkit-markdown>
              </div>
            }
            @if (note.analyst_note_pivots) {
              <div class="analyst-note-section">
                <hyperkit-markdown
                  [md]="note.analyst_note_pivots"
                ></hyperkit-markdown>
              </div>
            }
            @if (note.observed_commandlines?.length > 0) {
              <hyperkit-typography
                class="analyst-note-section"
                variant="emphasized"
                size="md"
                align="left"
                color="primary"
                >Associated Command Line Artifacts:</hyperkit-typography
              >
              <hyperkit-code-block
                [code]="note.observed_commandlines.join('\n')"
              ></hyperkit-code-block>
            }
            @if (note.huntpackage_attribution?.length > 0) {
              <div class="analyst-note-section">
                <hyperkit-typography
                  variant="emphasized"
                  size="md"
                  align="left"
                  color="primary"
                  >Hunt Package Attribution Links</hyperkit-typography
                >
                @for (
                  huntPackageUUID of note.huntpackage_attribution;
                  track huntPackageUUID
                ) {
                  <hyperkit-link
                    [href]="'/research/hunt-package/' + huntPackageUUID"
                    target="_blank"
                    variant="body"
                    size="sm"
                    color="secondary"
                    [text]="getHuntPackageNameByUUID(huntPackageUUID)"
                  >
                  </hyperkit-link>
                }
              </div>
            }
            @if (note.malware_names?.length > 0) {
              <div class="analyst-note-section">
                <hyperkit-typography
                  variant="emphasized"
                  size="md"
                  align="left"
                  color="primary"
                  >Associated Malware Names:</hyperkit-typography
                >
                @for (malwareName of note.malware_names; track malwareName) {
                  <hyperkit-link
                    [href]="getThreatNameSearchHref(malwareName)"
                    [target]="'_blank'"
                    variant="body"
                    size="sm"
                    align="left"
                    color="secondary"
                    [text]="malwareName"
                  >
                  </hyperkit-link>
                }
              </div>
            }
            @if (note.adversary_names?.length > 0) {
              <div class="analyst-note-section">
                <hyperkit-typography
                  variant="emphasized"
                  size="md"
                  align="left"
                  color="primary"
                  >Associated Adversary Names:</hyperkit-typography
                >
                @for (
                  adversaryName of note.adversary_names;
                  track adversaryName
                ) {
                  <hyperkit-link
                    [href]="getAdversaryNameSearchHref(adversaryName)"
                    [target]="'_blank'"
                    variant="body"
                    size="sm"
                    align="left"
                    color="secondary"
                    [text]="adversaryName"
                  >
                  </hyperkit-link>
                }
              </div>
            }
            @if (
              note.references?.titan_references?.length > 0 ||
              note.references?.cyborg_sources?.length > 0 ||
              note.references?.general_references?.length > 0
            ) {
              <div class="analyst-note-section">
                <hyperkit-typography
                  variant="emphasized"
                  size="md"
                  align="left"
                  color="primary"
                  >References</hyperkit-typography
                >
                <div class="references-container">
                  <div class="reference-section">
                    <hyperkit-badge
                      variant="neutral"
                      text="General"
                    ></hyperkit-badge>
                    @for (
                      ref of note.references?.general_references;
                      track ref
                    ) {
                      <hyperkit-link
                        [href]="ref.link"
                        target="_blank"
                        variant="body"
                        size="sm"
                        color="secondary"
                        [text]="ref.title"
                      >
                      </hyperkit-link>
                    } @empty {
                      <hyperkit-typography
                        display="block"
                        variant="body"
                        align="left"
                        color="primary"
                        >--</hyperkit-typography
                      >
                    }
                  </div>
                  <div class="reference-section">
                    <hyperkit-badge
                      variant="neutral"
                      text="Verity471 / TITAN"
                    ></hyperkit-badge>
                    @for (ref of note.references?.titan_references; track ref) {
                      <hyperkit-link
                        [href]="ref.link"
                        target="_blank"
                        variant="body"
                        size="sm"
                        color="secondary"
                        [text]="ref.title"
                      >
                      </hyperkit-link>
                    } @empty {
                      <hyperkit-typography
                        display="block"
                        variant="body"
                        align="left"
                        color="primary"
                        >--</hyperkit-typography
                      >
                    }
                  </div>
                  <div class="reference-section">
                    <hyperkit-badge
                      variant="neutral"
                      text="Intel 471 Sources"
                    ></hyperkit-badge>
                    @for (ref of note.references?.cyborg_sources; track ref) {
                      <hyperkit-link
                        [href]="ref.link"
                        target="_blank"
                        variant="body"
                        size="sm"
                        color="secondary"
                        [text]="ref.title"
                      >
                      </hyperkit-link>
                    } @empty {
                      <hyperkit-typography
                        display="block"
                        variant="body"
                        align="left"
                        color="primary"
                        >--</hyperkit-typography
                      >
                    }
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </hyperkit-ellipsis>
    } @empty {
      <hyperkit-typography variant="body" size="sm" color="secondary"
        >No analyst notes available.</hyperkit-typography
      >
    }
  </div>
</div>

<div class="threat-description-section">
  <hyperkit-typography
    id="threatDescription"
    variant="emphasized"
    size="sm"
    align="left"
    color="primary"
    >Threat Description</hyperkit-typography
  >
  @if (threatDescription) {
    <hyperkit-markdown [md]="threatDescription"></hyperkit-markdown>
  } @else {
    <hyperkit-typography
      display="block"
      variant="body"
      align="left"
      color="primary"
      >--</hyperkit-typography
    >
  }
</div>
